/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Interview_DescInputs */

const en_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare with AI-generated practice questions tailored to the specific role and industry. Use STAR method frameworks and proven salary negotiation strategies to walk into every interview with confidence.`)
};

const de_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereite dich mit KI-generierten Uebungsfragen vor, die auf die jeweilige Rolle zugeschnitten sind. Nutze STAR-Methode-Frameworks und bewaehrte Strategien zur Gehaltsverhandlung.`)
};

const fr_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare-toi avec des questions d'entrainement generees par IA et adaptees au poste vise. Utilise les cadres de la methode STAR et des strategies eprouvees de negociation salariale.`)
};

const es_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparese con preguntas de practica generadas por IA adaptadas al puesto especifico. Utilice marcos del metodo STAR y estrategias probadas de negociacion salarial para cada entrevista.`)
};

const it_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparati con domande di pratica generate dall'IA e adattate al ruolo specifico. Utilizza i framework del metodo STAR e strategie comprovate di negoziazione salariale per ogni colloquio.`)
};

const nl_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereid je voor met AI-gegenereerde oefenvragen afgestemd op de specifieke rol. Gebruik STAR-methode kaders en bewezen strategieen voor salarisonderhandeling bij elk gesprek.`)
};

const pl_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotuj sie z pytaniami treningowymi generowanymi przez AI, dostosowanymi do konkretnej roli. Korzystaj z ram metody STAR i sprawdzonych strategii negocjacji wynagrodzenia.`)
};

const fi_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmistaudu tekoaelyn luomilla harjoituskysymyksillae, jotka on raeaetaeloety kyseiseen tehtaevaean. Hyoedynnae STAR-menetelmaeae ja hyvaeksi havaittuja palkkaneuvottelustrategioita.`)
};

const da_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbered dig med AI-genererede oevelsessporgsmaal tilpasset den specifikke rolle. Brug STAR-metode-rammer og gennemproevede strategier til loenforhandling ved hver samtale.`)
};

const sv_landing_feature_interview_desc = /** @type {(inputs: Landing_Feature_Interview_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbered dig med AI-genererade oevningsfragor anpassade till den specifika rollen. Anvaend STAR-metod-ramverk och beproevade strategier foer loenefoerhandling vid varje intervju.`)
};

/**
* | output |
* | --- |
* | "Prepare with AI-generated practice questions tailored to the specific role and industry. Use STAR method frameworks and proven salary negotiation strategies ..." |
*
* @param {Landing_Feature_Interview_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_interview_desc = /** @type {((inputs?: Landing_Feature_Interview_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Interview_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_interview_desc(inputs)
	if (locale === "fr") return fr_landing_feature_interview_desc(inputs)
	if (locale === "es") return es_landing_feature_interview_desc(inputs)
	if (locale === "it") return it_landing_feature_interview_desc(inputs)
	if (locale === "nl") return nl_landing_feature_interview_desc(inputs)
	if (locale === "pl") return pl_landing_feature_interview_desc(inputs)
	if (locale === "fi") return fi_landing_feature_interview_desc(inputs)
	if (locale === "da") return da_landing_feature_interview_desc(inputs)
	if (locale === "sv") return sv_landing_feature_interview_desc(inputs)
	return en_landing_feature_interview_desc(inputs)
});